import parsePhoneNumber from 'libphonenumber-js';
import moment from 'moment';
export var composeValidators = function () {
    var validators = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        validators[_i] = arguments[_i];
    }
    return function (value) {
        return validators.reduce(function (error, validator) { return error || validator(value); }, undefined);
    };
};
export var required = function (message) {
    if (message === void 0) { message = 'This is a required field'; }
    return function (value) {
        switch (typeof value) {
            case 'object':
                if (Array.isArray(value)) {
                    return value.length ? undefined : message;
                }
                if (value instanceof Date) {
                    return value && !isNaN(value.valueOf()) ? undefined : message;
                }
                break;
            case 'number':
                return !isNaN(value) ? undefined : message;
        }
        return value ? undefined : message;
    };
};
export var regex = function (regex, errorMessage) { return function (value) {
    return value && typeof value === 'string' ? (!regex.test(value) ? errorMessage : undefined) : undefined;
}; };
var validEmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export var email = function (message) {
    if (message === void 0) { message = 'Enter a valid email'; }
    return regex(validEmailRegex, message);
};
export var min = function (floor, message) {
    if (message === void 0) { message = 'Too low'; }
    return function (value) {
        return (value !== null && value !== void 0 ? value : false) ? (Number(value) >= Number(floor) ? undefined : message) : undefined;
    };
};
export var max = function (ceil, message) {
    if (message === void 0) { message = 'Too high'; }
    return function (value) {
        return (value !== null && value !== void 0 ? value : false) ? (Number(value) <= Number(ceil) ? undefined : message) : undefined;
    };
};
export var maxLength = function (max, errorMessage) {
    if (errorMessage === void 0) { errorMessage = 'Too long'; }
    return function (value) {
        return value && (typeof value === 'string' || Array.isArray(value))
            ? value.length > max
                ? errorMessage
                : undefined
            : undefined;
    };
};
export var minLength = function (min, errorMessage) {
    if (errorMessage === void 0) { errorMessage = 'Too short'; }
    return function (value) {
        return value && (typeof value === 'string' || Array.isArray(value))
            ? value.length < min
                ? errorMessage
                : undefined
            : undefined;
    };
};
var nameRegex = /^[a-zA-Z\-'. ]+$/;
export var name = function (message) {
    if (message === void 0) { message = 'Enter a valid name'; }
    return composeValidators(minLength(1, message), regex(nameRegex, message));
};
export var phoneNumber = function (message) {
    if (message === void 0) { message = 'Enter a valid phone number'; }
    return function (value) { var _a; return !value || ((_a = parsePhoneNumber("".concat(value), 'AU')) === null || _a === void 0 ? void 0 : _a.isValid()) ? undefined : message; };
};
var dateFormats = ['YYYY/MM/D', 'YYYY/MM/DD'];
// DATES
export var isDate = function (message) {
    if (message === void 0) { message = 'Enter a valid date'; }
    return function (value) {
        return !value || moment("".concat(value).replace(/-/g, '/'), dateFormats, true).isValid() ? undefined : message;
    };
};
export var before = function (before, message) {
    if (message === void 0) { message = "Must be before ".concat(moment(before).format('LL')); }
    return function (value) {
        return !value || moment("".concat(value).replace(/-/g, '/'), dateFormats, true).isBefore(moment(before))
            ? undefined
            : message;
    };
};
export var after = function (after, message) {
    if (message === void 0) { message = "Must be after ".concat(moment(after).format('LL')); }
    return function (value) {
        return !value || moment("".concat(value).replace(/-/g, '/'), dateFormats, true).isAfter(moment(after)) ? undefined : message;
    };
};
export var dob = function (message) {
    if (message === void 0) { message = 'Enter a valid date of birth'; }
    return composeValidators(isDate(message), after('1900-01-01', message), before(undefined, message));
};
// Check a medicare card for valid CheckSum.
// Note, we expect a 10-digit card, but only the first 9 are used in the validation, the 10th (the IRN) is required but ignored.
// the LineNo should not be passed in.
// Calculate the CheckSum as: ((digit 1) + (digit 2 * 3) + (digit 3 * 7) + (digit 4 * 9) + (digit 5) + (digit 6 * 3) + (digit 7 * 7) + (digit 8 * 9)) % 10
// Valid if (digit 9) = CheckSum
export var medicare = function (message) {
    if (message === void 0) { message = 'Invalid Medicare number'; }
    return function (value) {
        if (!value) {
            return undefined;
        }
        var valid = false;
        if (typeof value === 'string' && value.length === 10) {
            var multipliers = [1, 3, 7, 9];
            var sum = 0;
            for (var digit = 0; digit < 8; digit++) {
                sum += parseInt(value[digit]) * multipliers[digit % 4];
            }
            valid = parseInt(value[8]) === sum % 10;
        }
        return valid ? undefined : message;
    };
};
